"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Marker_1 = require("./Marker");
var PosterMarker_1 = require("./PosterMarker");
var SnapshotMarker_1 = require("./SnapshotMarker");
var MarkerFactoryImpl = (function () {
    function MarkerFactoryImpl() {
        this.constructMarkerFromRawData = function (rawMarkerData, version) {
            var config = {
                t: Marker_1.MarkerType.None
            };
            try {
                config = JSON.parse(rawMarkerData.cm);
            }
            catch (err) {
            }
            switch (config.t) {
                case Marker_1.MarkerType.Poster:
                    return new PosterMarker_1.PosterMarker(config, rawMarkerData, version);
                case Marker_1.MarkerType.Snapshot:
                    return new SnapshotMarker_1.SnapshotMarker(config, rawMarkerData, version);
                case Marker_1.MarkerType.None:
                default:
                    return new Marker_1.Marker(config, rawMarkerData, version);
            }
        };
    }
    return MarkerFactoryImpl;
}());
exports.MarkerFactory = new MarkerFactoryImpl();
//# sourceMappingURL=MarkerFactory.js.map